import { ParsedUrlQuery } from 'querystring';

export type RenewalEntryPoint = 'bookings';

const ENTRY_POINT_PARAM = 'from';

export const getRenewalEntryPoint = (
  query: ParsedUrlQuery | undefined
): RenewalEntryPoint | undefined =>
  query?.[ENTRY_POINT_PARAM] === 'bookings' ? 'bookings' : undefined;

export const withRenewalEntryPoint = (
  path: string,
  entryPoint: RenewalEntryPoint | undefined
): string => {
  if (!entryPoint) {
    return path;
  }
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}${ENTRY_POINT_PARAM}=${entryPoint}`;
};

export const getAddBreaksPath = (
  entryPoint: RenewalEntryPoint | undefined
): string => (entryPoint === 'bookings' ? '/bookings' : '/let2offset-renewal');

export const getReviewBreaksPath = (
  entryPoint: RenewalEntryPoint | undefined
): string => withRenewalEntryPoint('/let2offset-renewal/review', entryPoint);
